import React from "react";
import { Grid } from "semantic-ui-react";
import { convertToDollar } from "../../Helpers";
import "../../styles/ui.scss";

const BCLeaderboard = ({ ...props }) => {
  return (
    <Grid columns={3} divided='vertically' className="leaderboard-grid">
      {(props && props.data && props.labels) && props.data.map((item, i) => {
        return (
          <Grid.Row key={"leaderboard_" + i} className="leaderboard-item">
            <Grid.Column width={2}>{i + 1}</Grid.Column>
            {props.labels && props.labels.map((item, j) => {
              let value = "";
              if (item && item.value && item.format) {
                switch (item.format) {
                  case "dollar":
                    value = convertToDollar(props.data[i][item.value]);
                    break;
                  case "text":
                    value = item.value;
                    break;
                  default:
                    value = props.data[i][item.value];
                    break;
                }
              }
              return (
                <Grid.Column key={"legend_value_" + j}>
                  <span className="leaderboard-text">{value}</span>
                </Grid.Column>
              );
            })}
          </Grid.Row>
        );
      })}
    </Grid>
  );
};

export default BCLeaderboard;